/**
 * Offre à trois paliers — blocks/product-offer-tiers.liquid
 *
 * Injecte le produit additionnel du palier retenu sous la forme items[0][id] /
 * items[0][quantity], format déjà géré par product-form.js (le produit principal
 * est ajouté ensuite, et #mergeItemsById dédoublonne).
 *
 * Les prix sont recalculés côté client à chaque changement de palier, de parfum
 * ou de variante de la table :
 *     prix   = table + variante additionnelle × quantité − remise
 *     barré  = table + variante additionnelle × quantité
 * La « valeur » d'une variante ajoutée est son prix comparé quand elle en a un
 * (un kit vendu sous la somme de son contenu), sinon son prix : c'est elle qui
 * fait le prix barré. La remise, elle, reste visuelle et doit être adossée à une
 * remise automatique Shopify équivalente.
 *
 * Parfums d'un kit : les sélecteurs [data-potier-prop] partent en propriétés de
 * ligne du produit ajouté (items[0][properties][Parfum 1]).
 */
(function () {
  'use strict';

  if (window.__zoemassOfferTiers) return;
  window.__zoemassOfferTiers = true;

  function money(root, cents) {
    var currency = root.dataset.currency || 'EUR';
    var locale = root.dataset.locale || 'fr';
    try {
      var whole = cents % 100 === 0;
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    } catch (err) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  function getForm(root) {
    var productForm = root.closest('product-form');
    if (productForm) return productForm.querySelector('form[action$="/cart/add"]');
    return document.querySelector('product-form form[action$="/cart/add"]');
  }

  /** Prix de la variante de table actuellement choisie. */
  function basePrice(root) {
    var form = getForm(root);
    var container = form && form.querySelector('[data-ref="add-to-cart-button-container"]');
    if (container && container.dataset.price) {
      var live = parseInt(container.dataset.price, 10);
      if (!isNaN(live)) return live;
    }
    return parseInt(root.dataset.basePrice, 10) || 0;
  }

  /**
   * La photo de rappel sous les listes suit le choix fait juste au-dessus.
   *
   * Elle se cale sur le PREMIER sélecteur du palier. Sur le tabouret, qui n'a
   * qu'une unité, c'est exactement la couleur choisie. Sur les huiles, où l'on
   * peut prendre trois parfums, c'est celui du premier : les flacons étant
   * identiques à l'étiquette près, le rappel reste juste — et afficher trois
   * photos alourdirait la carte pour rien.
   */
  function syncPickVisual(option) {
    var img = option.querySelector('[data-potier-visual]');
    var select = option.querySelector('select[data-potier-variant]');
    if (!img || !select) return;

    var chosen = select.options[select.selectedIndex];
    var src = chosen && chosen.dataset.image;
    if (src && img.getAttribute('src') !== src) img.src = src;
  }

  /**
   * Unités additionnelles d'un palier : un contrôle = une unité.
   * Trois sélecteurs permettent donc trois parfums différents dans le même pack.
   * product-form.js regroupe ensuite les lignes identiques (#mergeItemsById),
   * donc deux fois le même parfum arrivent au panier en quantité 2.
   */
  function addons(option) {
    return Array.prototype.slice
      .call(option.querySelectorAll('[data-potier-variant]'))
      .map(function (input) {
        if (input.tagName === 'SELECT') {
          var selected = input.options[input.selectedIndex];
          if (!selected || !selected.value) return null;
          return {
            id: selected.value,
            price: parseInt(selected.dataset.price, 10) || 0,
            full: parseInt(selected.dataset.compare, 10) || parseInt(selected.dataset.price, 10) || 0,
          };
        }
        if (!input.value) return null;
        return {
          id: input.value,
          price: parseInt(input.dataset.price, 10) || 0,
          full: parseInt(input.dataset.compare, 10) || parseInt(input.dataset.price, 10) || 0,
        };
      })
      .filter(Boolean);
  }

  function refresh(root) {
    var base = basePrice(root);
    var gifts = parseInt(root.dataset.gifts, 10) || 0;
    var countGifts = root.dataset.includeGifts === '1';

    /**
     * Seuil de crédibilité, en pourcentage du prix de la formule.
     *
     * Une économie de 64,90 € sur une table à 6 900 € est exacte et pourtant
     * contre-productive : rapportée au prix elle ressemble à une remise de
     * façade. En dessous du seuil, la pastille et le prix barré disparaissent —
     * ici comme dans la barre d'achat, qui reçoit alors un prix barré vide.
     * Le calcul est refait à chaque changement de variante : c'est le prix
     * affiché, pas celui du rendu initial, qui décide.
     */
    var minPercent = parseFloat(root.dataset.saveMinPercent) || 0;

    root.querySelectorAll('[data-potier-opt]').forEach(function (option) {
      var entries = addons(option);
      var remise = parseInt(option.dataset.remise, 10) || 0;
      var addonsTotal = entries.reduce(function (sum, entry) {
        return sum + entry.price;
      }, 0);
      var addonsFull = entries.reduce(function (sum, entry) {
        return sum + Math.max(entry.full, entry.price);
      }, 0);
      // Contenu détaillé : sa somme fait la valeur « à l'unité », comme en Liquid.
      var itemsTotal = parseInt(option.dataset.itemsTotal, 10) || 0;
      if (itemsTotal > 0 && entries.length) addonsFull = itemsTotal;
      var full = base + addonsFull;
      var net = Math.max(base + addonsTotal - remise, 0);

      var fullValue = root.dataset.saveFull === '1' && entries.length > 0;
      var save = remise + (fullValue ? addonsFull : addonsFull - addonsTotal) + (countGifts ? gifts : 0);
      var credible = save > 0 && full > 0 && save * 100 >= full * minPercent;

      var priceEl = option.querySelector('[data-potier-price]');
      if (priceEl) priceEl.textContent = money(root, net);

      var htEl = option.querySelector('[data-potier-ht]');
      if (htEl) {
        var vat = parseFloat(root.dataset.vatRate) || 0;
        htEl.textContent = money(root, Math.round(net / (1 + vat / 100))) + ' HT';
      }

      var wasEl = option.querySelector('[data-potier-was]');
      if (wasEl) {
        wasEl.textContent = money(root, full);
        wasEl.hidden = !credible;
      }

      var saveEl = option.querySelector('[data-potier-save]');
      if (saveEl) {
        var saveAmount = saveEl.querySelector('strong');
        if (saveAmount) saveAmount.textContent = money(root, save);
        saveEl.hidden = !credible;
      }

      // Les deux pastilles s'excluent : quand le montant n'est pas crédible,
      // c'est le nom du cadeau qui porte l'avantage.
      var perkEl = option.querySelector('[data-potier-perk]');
      if (perkEl) perkEl.hidden = credible;

      // Mémorisé pour que la barre d'achat puisse afficher le total du palier.
      option.dataset.net = net;
      option.dataset.full = full;
      option.dataset.showSave = credible ? '1' : '0';
    });
  }

  /**
   * La barre d'achat affiche le prix de la variante, pas celui de la formule
   * choisie. On lui envoie le total du palier pour qu'elle reste cohérente.
   */
  function publish(root) {
    var checked = root.querySelector('input[type="radio"]:checked');
    var option = checked && checked.closest('[data-potier-opt]');
    if (!option) return;

    var net = parseInt(option.dataset.net, 10);
    var full = parseInt(option.dataset.full, 10);
    if (isNaN(net)) return;

    // Sous le seuil de crédibilité, la barre d'achat ne reçoit aucun prix barré :
    // sinon « 6 900,00 € » précédé de « 6 964,90 € » rayé raconterait en haut de
    // page exactement la remise de façade qu'on vient de retirer plus bas.
    var comparable = option.dataset.showSave !== '0' && !isNaN(full);

    document.dispatchEvent(
      new CustomEvent('zoemass:offer-updated', {
        detail: { price: net, compareAtPrice: comparable ? full : null },
      })
    );
  }

  function clearInjected(form) {
    form.querySelectorAll('[data-potier-injected]').forEach(function (node) {
      node.remove();
    });
  }

  function apply(root) {
    var checked = root.querySelector('input[type="radio"]:checked');
    if (!checked) return;

    root.querySelectorAll('[data-potier-opt]').forEach(function (option) {
      option.classList.remove('is-active');
    });

    var option = checked.closest('[data-potier-opt]');
    if (option) option.classList.add('is-active');

    var error = root.querySelector('[data-potier-error]');
    if (error) error.hidden = true;

    publish(root);

    var form = getForm(root);
    if (!form) return;

    clearInjected(form);

    var entries = option ? addons(option) : [];

    var props = option
      ? Array.prototype.slice.call(option.querySelectorAll('select[data-potier-prop]')).map(function (select) {
          return { name: select.dataset.potierProp, value: select.value };
        })
      : [];

    entries.forEach(function (entry, index) {
      var fields = [
        ['id', entry.id],
        ['quantity', '1'],
      ];
      // Les parfums choisis se posent sur la première ligne ajoutée (le kit).
      if (index === 0) {
        props.forEach(function (prop) {
          if (prop.name && prop.value) fields.push(['properties][' + prop.name, prop.value]);
        });
      }
      fields.forEach(function (pair) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'items[' + index + '][' + pair[0] + ']';
        input.value = pair[1];
        input.setAttribute('data-potier-injected', '');
        form.appendChild(input);
      });
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target.matches) return;

    if (target.matches('[data-potier-prop]')) {
      var propRoot = target.closest('product-offer-tiers');
      if (propRoot) apply(propRoot);
      return;
    }

    if (target.matches('[data-potier-variant]')) {
      var variantRoot = target.closest('product-offer-tiers');
      if (!variantRoot) return;

      var variantOpt = target.closest('[data-potier-opt]');
      if (variantOpt) syncPickVisual(variantOpt);

      refresh(variantRoot);
      apply(variantRoot);
      return;
    }

    if (target.matches('.potier input[type="radio"]')) {
      var radioRoot = target.closest('product-offer-tiers');
      if (radioRoot) apply(radioRoot);
    }
  });

  /** Lit une table de correspondance posée en attribut, sans jamais lever. */
  function readMap(root, name) {
    try {
      return JSON.parse(root.dataset[name] || '{}');
    } catch (error) {
      return {};
    }
  }

  /**
   * Aligne la formule sur le coloris choisi.
   *
   * Trois choses en dépendent et étaient jusqu'ici figées sur la variante par
   * défaut : la vignette, la pile de cadeaux, et la valeur totale annoncée.
   * Tout est déjà dans la page — il n'y a qu'à désigner la bonne.
   */
  function selectVariant(root, id) {
    if (!id) return;

    var thumbs = readMap(root, 'thumbMap');
    var url = thumbs[id];
    if (url) {
      root.querySelectorAll('[data-potier-thumb]').forEach(function (img) {
        if (img.getAttribute('src') !== url) img.src = url;
      });
    }

    var piles = root.querySelectorAll('[data-potier-gifts]');
    if (piles.length) {
      piles.forEach(function (pile) {
        pile.hidden = pile.dataset.potierGifts !== String(id);
      });
    }

    var gifts = readMap(root, 'giftsMap');
    if (Object.prototype.hasOwnProperty.call(gifts, id)) {
      root.dataset.gifts = gifts[id];
    }
  }

  /** Valeur affichée en tête de pile : cadeaux + unité offerte du palier. */
  function refreshWorth(root) {
    var gifts = parseInt(root.dataset.gifts, 10) || 0;

    root.querySelectorAll('[data-potier-opt]').forEach(function (option) {
      var worth = option.querySelector('[data-potier-worth]');
      if (!worth) return;
      var remise = parseInt(option.dataset.remise, 10) || 0;
      worth.textContent = money(root, gifts + remise) + ' de valeur';
    });
  }

  document.addEventListener('variant:updated', function (event) {
    var variant = event.detail && event.detail.resource;

    document.querySelectorAll('product-offer-tiers').forEach(function (root) {
      if (variant && variant.id) selectVariant(root, variant.id);
      refresh(root);
      refreshWorth(root);
      apply(root);
    });
  });

  // La barre d'achat s'initialise après ce bloc et réclame le total en vigueur.
  // Au chargement, chaque palier part sur la photo de son choix par défaut.
  document.querySelectorAll('[data-potier-opt]').forEach(syncPickVisual);

  document.addEventListener('zoemass:offer-request', function () {
    document.querySelectorAll('product-offer-tiers').forEach(publish);
  });

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.matches || !form.matches('form[action$="/cart/add"]')) return;

      var productForm = form.closest('product-form');
      var root =
        (productForm && productForm.querySelector('product-offer-tiers')) ||
        document.querySelector('product-offer-tiers');
      if (!root) return;

      if (!root.querySelector('input[type="radio"]:checked')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        var error = root.querySelector('[data-potier-error]');
        if (error) error.hidden = false;
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    },
    true
  );

  function init() {
    document.querySelectorAll('product-offer-tiers').forEach(function (root) {
      refresh(root);
      apply(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
